




import { Vue, Component } from "vue-property-decorator";
import { getAccessTokenByRefreshToken } from "@/general/store/api";
import { TokenRefreshRequest } from "gen/authapi/api";
import commons from "@/common/store/modules/commons";

import { getOrganizationAdminSettings } from "@/general/store/api";
import permissions from "@/admin/store/modules/rolePermissions";
import { getAdminOnlyGroups, getUserRoles } from "@/admin/store/api";
import {  getUserGroupRole } from "@/general/store/api";
import auth from "@/general/store/modules/auth";
import LocalStorage from "@/general/utils/storage";

@Component({})
export default class SwitchSite extends Vue {
  async isAdmin(user: number) {
    const adminRoles = [2, 3, 4, 5];
    const response = await getUserGroupRole(
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      user.toString()
    );
    const checkAdmin = response.results?.find(item => {
      return adminRoles.includes(item.role.role_type);
    });

    if (checkAdmin === undefined) {
      return false;
    } else {
      return true;
    }
  }

  async created() {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    const token = urlParams.get("token")
      ? (urlParams.get("token") as string)
      : "";

    if (token == "") {
      window.location.href = "/system-error/";
    } else {
      const refreshToken: TokenRefreshRequest = {
        refresh: token
      };

      const response = await getAccessTokenByRefreshToken(refreshToken);

      LocalStorage.setItem("AccessToken", response.access);
      LocalStorage.setItem("RefreshToken", response.refresh);

      const orgAdminSettings = await getOrganizationAdminSettings();
      LocalStorage.setItem(
        "orgAdminSettings",
        JSON.stringify(orgAdminSettings.results)
      );

      await commons.getOrgPageSpecificById(auth.user?.organization_id);

      const onLoginRedirect = LocalStorage.getItem("ON_LOGIN_REDIRECT");

      if (commons.headerInfo.pageType == "admin") {
        LocalStorage.setItem("userIsAdmin", "1");
        LocalStorage.setItem("adminSite", "1");

        // Role Permissions
        LocalStorage.removeItem("USER_GROUP_ROLE_PERMISSIONS");

        const groups = [];
        const adminGroups: any = await getAdminOnlyGroups();
        if (adminGroups && adminGroups.results) {
          for (let i = 0; i < adminGroups.results.length; i++) {
            groups.push({
              id: adminGroups.results[i].group?.id,
              name: adminGroups.results[i].group?.name
            });
          }
        }

        LocalStorage.setItem("USER_GROUPS", JSON.stringify(groups));
        LocalStorage.setItem("USER_GROUP_ID", groups[0].id + "");

        window.sessionStorage.setItem("selectedGroupName", groups[0].name);
        window.sessionStorage.setItem("selectedGroupId", groups[0].id + "");

        LocalStorage.setItem(
          "OrgSpecificData",
          JSON.stringify(commons.OrgPageSpecific)
        );

        await permissions.loadPermissions();

        const roles: any = await getUserRoles();
        LocalStorage.setItem("USER_ROLES", JSON.stringify(roles));

        if (onLoginRedirect) {
          LocalStorage.removeItem("ON_LOGIN_REDIRECT");
          window.location.href = onLoginRedirect;
        } else {
          window.location.href = "/dashboard/";
        }
      } else {
        const isAdmin = await this.isAdmin(auth.user?.user_id);
        if (isAdmin) {
          LocalStorage.setItem("userIsAdmin", "1");
        } else {
          LocalStorage.setItem("userIsAdmin", "0");
        }

        LocalStorage.setItem("adminSite", "0");

        LocalStorage.setItem(
          "OrgSpecificData",
          JSON.stringify(commons.OrgPageSpecific)
        );

        if (onLoginRedirect) {
          LocalStorage.removeItem("ON_LOGIN_REDIRECT");
          window.location.href = onLoginRedirect;
        } else {
          window.location.href = "/home";
        }
      }
    }
  }
}
